export const TURN_TYPE_DEFINITIONS = [
  {
    value: 0,
    key: "point",
    label: "Point",
    sfSymbol: "mappin.circle.fill",
    cmsIconKey: "map-pin",
  },
  {
    value: 1,
    key: "continueStraight",
    label: "Continue Straight",
    sfSymbol: "arrow.up.square.fill",
    cmsIconKey: "arrow-up",
  },
  {
    value: 2,
    key: "rightTurn",
    label: "Right Turn",
    sfSymbol: "arrow.right.square.fill",
    cmsIconKey: "arrow-right",
  },
  {
    value: 3,
    key: "leftTurn",
    label: "Left Turn",
    sfSymbol: "arrow.left.square.fill",
    cmsIconKey: "arrow-left",
  },
  {
    value: 4,
    key: "uTurn",
    label: "U-Turn",
    sfSymbol: "arrow.uturn.down.square.fill",
    cmsIconKey: "arrow-back-up",
  },
  {
    value: 5,
    key: "roundaboutTurn",
    label: "Roundabout Turn",
    sfSymbol: "arrow.trianglehead.2.counterclockwise.rotate.90",
    cmsIconKey: "rotate-clockwise-2",
  },
  {
    value: 6,
    key: "mergeTurn",
    label: "Merge Turn",
    sfSymbol: "arrow.trianglehead.merge",
    cmsIconKey: "arrows-join",
  },
  {
    value: 7,
    key: "slipRoadTurn",
    label: "Slip Road Turn",
    sfSymbol: "arrow.trianglehead.branch",
    cmsIconKey: "git-branch",
  },
  {
    value: 8,
    key: "laneChangeFromRight",
    label: "Lane Change From Right",
    sfSymbol: "car.top.lane.dashed.departure.left.fill",
    cmsIconKey: "lane",
  },
  {
    value: 9,
    key: "laneChangeFromLeft",
    label: "Lane Change From Left",
    sfSymbol: "car.top.lane.dashed.departure.right.fill",
    cmsIconKey: "lane",
  },
  {
    value: 10,
    key: "offsetTurn",
    label: "Offset Turn",
    sfSymbol: "arrowshape.turn.up.right.fill",
    cmsIconKey: "arrow-ramp-right",
  },
  {
    value: 11,
    key: "dividedHighwayCrossover",
    label: "Divided Highway Crossover",
    sfSymbol: "arrow.left.and.line.vertical.and.arrow.right",
    cmsIconKey: "arrows-left-right",
  },
  {
    value: 12,
    key: "parking",
    label: "Parking",
    sfSymbol: "parkingsign.circle.fill",
    cmsIconKey: "parking",
  },
];

export function getTurnTypeDefinitionByValue(value) {
  const numericValue = Number(value);
  return TURN_TYPE_DEFINITIONS.find((item) => item.value === numericValue) || null;
}
